const WORDS = ["Managed IT", "Managed Dispatch", "Onsite Support", "Nationwide USA", "Fair Pricing", "24/7 Helpdesk"];

export const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  return (
    <section data-testid="editorial-marquee" aria-label="Capabilities" className="marquee overflow-hidden border-y border-slate-200 bg-[#FAFCFF] py-8 sm:py-10">
      <div className="marquee-track flex w-max items-center">
        {row.map((w, i) => (
          <span key={i} className="flex items-center whitespace-nowrap font-display text-5xl font-semibold tracking-tight sm:text-7xl lg:text-8xl">
            <span className={i % 2 ? "text-outline" : "text-slate-900"}>{w}</span>
            <span className="mx-8 inline-block h-3 w-3 rounded-full bg-gradient-to-br from-[#1777AF] to-[#29C1D3] sm:mx-12" />
          </span>
        ))}
      </div>
    </section>
  );
};
